import _toConsumableArray from "D:/VUE\u5EB7\u4E50\u901A\u603B\u540E\u53F0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "D:/VUE\u5EB7\u4E50\u901A\u603B\u540E\u53F0/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/VUE\u5EB7\u4E50\u901A\u603B\u540E\u53F0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { TUIGroupService, TUIStore, StoreName, TUITranslateService } from "@tencentcloud/chat-uikit-engine";
import { ref, watchEffect } from "../../../adapter-vue";
import { Toast, TOAST_TYPE } from "../../common/Toast/index";
import TUICore from "@tencentcloud/tui-core";
import SelectUser from "../../common/SelectUser/index.vue";
import Server from "../server";
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup: function setup(__props) {
    var TUIContactServer = Server.getInstance();
    var TUIConstants = TUIContactServer.constants;
    var needSearch = ref(false);
    var memberList = ref([]);
    var userList = ref([]);
    var group = ref({});
    var selectOptions = ref({
      groupID: '',
      isRadio: false,
      isNeedSearch: false,
      title: '',
      filterUserIDList: []
    });
    var TUISearchServer = ref(null);
    var generateSearchServer = function generateSearchServer(isNeedSearch) {
      TUISearchServer.value = TUICore.getService(TUIConstants.TUISearch.SERVICE.NAME);
      if (TUISearchServer.value) {
        needSearch.value = isNeedSearch;
      } else {
        console.warn('请添加 TUISearch 组件');
      }
    };
    watchEffect(function () {
      var params = TUIContactServer.getOnCallParams(TUIConstants.TUIContact.SERVICE.METHOD.SELECT_FRIEND);
      selectOptions.value.groupID = params.groupID;
      selectOptions.value.title = params.title;
      selectOptions.value.isRadio = params.isRadio;
      selectOptions.value.isNeedSearch = params.isNeedSearch;
      selectOptions.value.filterUserIDList = params.filterUserIDList;
      if (params.isNeedSearch) {
        generateSearchServer(params.isNeedSearch);
      }
    });
    TUIStore.watch(StoreName.GRP, {
      currentGroup: function currentGroup(data) {
        group.value = data;
      },
      currentGroupMemberList: function currentGroupMemberList(List) {
        memberList.value = List.map(function (item) {
          if (selectOptions.value.filterUserIDList.indexOf(item.userID) > -1) {
            item.isDisabled = true;
          }
        });
        userList.value = memberList.value;
      }
    });
    var getMember = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var groupID, options;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              groupID = group.value.groupID;
              options = {
                groupID: groupID,
                count: 100,
                offset: memberList.value.length
              };
              _context.next = 4;
              return TUIGroupService.getGroupMemberList(options);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function getMember() {
        return _ref.apply(this, arguments);
      };
    }();
    var handleSelectedResult = function handleSelectedResult(memberList) {
      TUIStore.update(StoreName.GRP, "isShowSelectComponent", false);
      var callback = TUIContactServer.getOnCallCallback(TUIConstants.TUIGroup.SERVICE.METHOD.SELECT_GROUP_MEMBER);
      callback && callback(memberList);
    };
    var searchFail = function searchFail() {
      Toast({
        message: TUITranslateService.t("TUIGroup.该用户不存在"),
        type: TOAST_TYPE.ERROR
      });
      userList.value = _toConsumableArray(memberList.value);
    };
    var handleSearch = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(val) {
        var imResponse, searchAllResult;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (val) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return", userList.value = memberList.value);
            case 2:
              _context2.prev = 2;
              _context2.next = 5;
              return TUISearchServer.value.searchGroupMember(val);
            case 5:
              imResponse = _context2.sent;
              if (imResponse.data[0]) {
                _context2.next = 8;
                break;
              }
              return _context2.abrupt("return", searchFail());
            case 8:
              userList.value = imResponse.data;
              searchAllResult = memberList.value.filter(function (item) {
                return item.userID === imResponse.data[0].userID;
              });
              memberList.value = searchAllResult.length ? memberList.value : [].concat(_toConsumableArray(memberList.value), _toConsumableArray(userList.value));
              _context2.next = 16;
              break;
            case 13:
              _context2.prev = 13;
              _context2.t0 = _context2["catch"](2);
              return _context2.abrupt("return", searchFail());
            case 16:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[2, 13]]);
      }));
      return function handleSearch(_x) {
        return _ref2.apply(this, arguments);
      };
    }();
    return function (_ctx, _cache) {
      return _openBlock(), _createBlock(SelectUser, {
        isRadio: _unref(selectOptions).isRadio,
        isNeedSearch: _unref(selectOptions).isNeedSearch,
        title: _unref(selectOptions).title,
        userList: _unref(userList),
        total: _unref(group).memberCount,
        onGetMore: getMember,
        onSearch: handleSearch,
        onComplete: handleSelectedResult
      }, null, 8, ["isRadio", "isNeedSearch", "title", "userList", "total"]);
    };
  }
});